import invoicesReducer from "./invoicesSlice";
import invoiceReducer from "./invoiceSlice";

const invoices = {
  invoices: invoicesReducer,
  invoice: invoiceReducer,
};

export default invoices;
